import React from 'react';
import { useTranslation } from 'react-i18next';
import { BlurStarIcon } from '../../../assets/images/icons';
import styles from '../SubscriptionDowngrade.module.css';

const PlanFeatures = () => {
  const { t } = useTranslation();
  
  const features = [
    {
      name: t('subscription.features.data_analyzing'),
      description: t('subscription.features.data_analyzing_desc')
    },
    {
      name: t('subscription.features.data_analyzing'),
      description: t('subscription.features.data_analyzing_desc')
    },
    {
      name: t('subscription.features.data_analyzing'),
      description: t('subscription.features.data_analyzing_desc')
    },
    {
      name: t('subscription.features.data_analyzing'),
      description: t('subscription.features.data_analyzing_desc')
    }
  ];
  
  return (
    <div className={styles.featuresSection}>
      <p className={styles.featureHeading}>{t('subscription.how_it_works')}</p>
      <p className={styles.featureDescription}>{t('subscription.feature_description')}</p>
      <div style={{ display: 'flex', margin: '30px 0px', gap: '20px', flexWrap: 'wrap', maxWidth: '1200px', justifyContent: 'center' }}>
        {features.map((feature, index) => (
          <div key={index} className={styles.featureContainer}>
            <img src={BlurStarIcon} className={styles.starIcon} alt="Feature icon" />
            <p className={styles.featureName}>{feature.name}</p>
            <p className={styles.specificFeatureDescription}>{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlanFeatures; 